const promotions = {
    "TotalItems": 10,
    "TotalCurrentUser": 10,
    "TotalForSearch": 10,
    "Promotions": [
        {
            "PromotionId": 94286,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Costa Club Punta Arena - All Inclusive en Puerto Vallarta",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 15081.0263952660000,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Costa Club Punta Arena - All Inclusive\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Double Room King Bed\u0022,\u0022Category\u0022:3,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100160\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100160/425287-0861eb1e_z_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsCostaClubPuntaArena-AllInclusive6",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94287,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Grand Decameron Complex, A Trademark All-Inclusive en Bucer\u00EDas",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 11919.4500000000000,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Grand Decameron Complex, A Trademark All-Inclusive\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Double Standard\u0022,\u0022Category\u0022:3,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022102233\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/102233/485427-8bda5ebb_z_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsGrandDecameronComplex,ATrademarkA97",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94288,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Samba Vallarta All Inclusive Beach Resort by Emporio Hotels en Nuevo Vallarta",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 15744.3306732222738,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Samba Vallarta All Inclusive Beach Resort by Emporio Hotels\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Est\u00E1ndar 2 dobles con balc\u00F3n\u0022,\u0022Category\u0022:4,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022101480\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/UJVZD7IJA0ppA6g-o73YibNTTLg=/720x480/04/57/82/04578287.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsSambaVallartaAllInclusiveBeachRes94",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94273,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Moon Palace Cancun en Canc\u00FAn",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 2,
            "DtStart": "2025-10-02T00:00:00",
            "DtEnd": "2025-10-05T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 21561.5188955319620,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 02 oct. 2025 a 05 oct. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Moon Palace Cancun\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Superior de Lujo Vista al Jard\u00EDn\u0022,\u0022Category\u0022:5,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100409\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100409/428588-771fad9d_z_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsMoonPalaceCancun83",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94274,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Occidental Tucancun en Canc\u00FAn",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 4,
            "Kids": 0,
            "DtStart": "2025-10-06T00:00:00",
            "DtEnd": "2025-10-09T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 15044.5689557906281,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 06 oct. 2025 a 09 oct. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Occidental Tucancun\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Doble\u0022,\u0022Category\u0022:4,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100038\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100038/f5e4927f21efc2dfad9d38ed4591e4461a52da1e6aefb77c29b6e35089ea6203_main.png",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsOccidentalTucancun52",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94276,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "The Reef Playacar Beach Resort \u0026 Spa - Optional All Inclusive en Playa del Carmen - Riviera Maya",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 2,
            "DtStart": "2025-10-02T00:00:00",
            "DtEnd": "2025-10-05T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 10342.3640265638457,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 02 oct. 2025 a 05 oct. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022The Reef Playacar Beach Resort \u0026 Spa - Optional All Inclusive\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Superior 2 dobles\u0022,\u0022Category\u0022:4,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100579\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100579/794331-0bf0eafc_z_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsTheReefPlayacarBeachResort\u0026Spa-Op3",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94282,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Real Bananas ACA - Todo Incluido en Acapulco",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 7637.2499818299984,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Real Bananas ACA - Todo Incluido\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Est\u00E1ndar\u0022,\u0022Category\u0022:4,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100137\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100137/8324a3da-cfa8-4394-91cd-c1f7ee8ea66c_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsRealBananasACA-TodoIncluido63",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94283,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Krystal Beach Acapulco en Acapulco",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 11903.8672188764852,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Krystal Beach Acapulco\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Est\u00E1ndar king vista a la monta\u00F1a\u0022,\u0022Category\u0022:3,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022100013\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/100013/2830d00e-d21e-4731-a549-53581520c40d_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsKrystalBeachAcapulco87",
            "PromotionPaymentMethodInfo": 1
        },
        {
            "PromotionId": 94284,
            "PromoMakerId": 1,
            "CreatedByUserId": 193165,
            "ProductTypeId": 1,
            "AgencyId": 19610,
            "AffiliateId": 300,
            "Name": "Palacio Mundo Imperial Riviera Diamante Acapulco en Acapulco",
            "Description": "Hosp\u00E9date por 4 d\u00EDas y 3 noches",
            "Adults": 2,
            "Kids": 0,
            "DtStart": "2025-08-14T00:00:00",
            "DtEnd": "2025-08-17T00:00:00",
            "DtQuote": "2025-07-15T00:00:00",
            "ContactEmail": "fabriciofabras@gmail.com",
            "ContactPhone": "(56)1898-4696",
            "Total": 18836.3750000000000,
            "Policies": "Consulta t\u00E9rminos y condiciones. Promoci\u00F3n sujeta a disponibilidad y cambio sin previo aviso. Viaja del 14 ago. 2025 a 17 ago. 2025. Impuestos incluidos.",
            "PromotionDetail": "{\u0022PromotionHotelDetail\u0022:{\u0022HotelName\u0022:\u0022Palacio Mundo Imperial Riviera Diamante Acapulco\u0022,\u0022Nights\u0022:\u00223\u0022,\u0022Room\u0022:\u0022Double Deluxe\u0022,\u0022Category\u0022:5,\u0022MealPlan\u0022:\u0022Todo incluido\u0022,\u0022HotelId\u0022:\u0022210480\u0022},\u0022PromotionAddonDetail\u0022:[]}",
            "PromotionRequest": "",
            "UrlImage": "https://img.cdnpth.com/media/210480/2191784-ad3ec0fe_z_main.jpg",
            "IsActive": true,
            "Scope": true,
            "Status": null,
            "PromotionCode": "TravelFriendsPalacioMundoImperialRivieraDiaman93",
            "PromotionPaymentMethodInfo": 1
        }
    ],
    "TotalPages": 2,
    "CurrentPage": 1
}

export default promotions;
